<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row no-gutters>
          <v-col sm="12" md="10">
            <span>
              {{ this.title }}
            </span>
          </v-col>
          <v-col sm="12" md="2">
            <v-avatar v-if="styleTile" tile color="grey" size="28px">
              <img v-if="img" :src="img" />
            </v-avatar>
            <v-avatar v-else size="48px">
              <img v-if="img" :src="img" />
              <v-icon v-else color="indigo"> mdi-account-circle </v-icon>
            </v-avatar>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content v-if="isAllowed"
        ><v-card-text>
          <vue-avatar
            :width="400"
            :height="400"
            :rotation="rotation"
            :scale="scale"
            :image="image"
            :readonly="true"
            ref="vueavatar"
            @vue-avatar-editor:image-ready="onImageReady"
          >
          </vue-avatar>
          <v-tooltip x-small bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click="removerImg"
                color="error"
                v-bind="attrs"
                v-on="on"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Remover imagem</span>
          </v-tooltip>
        </v-card-text>
        <v-divider></v-divider
        ><v-card-actions>
          <v-slider
            v-model="scale"
            color="primary"
            label="Zoom"
            min="1"
            max="3"
            step="0.02"
            thumb-label
          ></v-slider>

          <v-slider
            v-model="rotation"
            color="primary"
            label="Rotação"
            min="0"
            max="360"
            step="1"
            thumb-label
          ></v-slider>
        </v-card-actions>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <!--<div>
    <v-card class="mx-auto" max-width="344">
      <v-list-item one-line>
        <v-list-item-content>
          <v-list-item-title class="mb-4">
            {{ title }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-avatar color="indigo" size="48">
          <img v-if="img" :src="img" />
          <v-icon v-else dark> mdi-account-circle </v-icon>
        </v-list-item-avatar>
      </v-list-item>
      <v-card-actions>
        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>

          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">
                
              </div>
              <v-list-item-title class="headline mb-1">
                <vue-avatar
                  :width="400"
                  :height="400"
                  :rotation="rotation"
                  :scale="scale"
                  :image="image"
                  ref="vueavatar"
                  @vue-avatar-editor:image-ready="onImageReady"
                >
                </vue-avatar>
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="removerImg"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
            <v-slider
              v-model="scale"
              color="orange"
              label="Zoom"
              min="1"
              max="3"
              step="0.02"
              thumb-label
            ></v-slider>

            <v-slider
              v-model="rotation"
              color="orange"
              label="Rotação"
              min="0"
              max="360"
              step="1"
              thumb-label
            ></v-slider>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </v-card>
    <!--<md-card class="md-primary" md-theme="green-card">
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">{{ title }}</div>
        </md-card-header-text>
      </md-card-header>
      <md-card-media-actions>
        <md-card-media>
          <vue-avatar
            :width="400"
            :height="400"
            :rotation="rotation"
            :scale="scale"
            :image="image"
            ref="vueavatar"
            @vue-avatar-editor:image-ready="onImageReady"
          >
          </vue-avatar>
        </md-card-media>
        <md-card-actions>
          <md-button class="md-icon-button" @click="removerImg">
            <md-icon>cancel</md-icon>
          </md-button>
        </md-card-actions>
      </md-card-media-actions>
      <md-card-actions>
        <label>
          Zoom : {{ scale }}x
          <br />
          <input type="range" min="1" max="3" step="0.02" v-model="scale" />
        </label>
        <label>
          Rotation : {{ rotation }}°
          <br />
          <input type="range" min="0" max="360" step="1" v-model="rotation" />
        </label>
      </md-card-actions>
    </md-card>
  </div>-->
</template>

<script>
import { VueAvatar, VueAvatarScale } from "vue-avatar-editor-improved";

export default {
  name: "avatar",
  data: () => ({
    rotation: 0,
    scale: 1,
    image: "",
    img: null,
  }),
  props: {
    title: String,
    styleTile: Boolean,
    isAllowed: Boolean,
  },
  methods: {
    onImageReady() {
      this.scale = 1;
      this.rotation = 0;
      this.img = this.$refs.vueavatar.getImageScaled().toDataURL();
    },
    removerImg() {
      this.$refs.vueavatar.resetImage();
      this.img = null;
    },
    getImg() {
      /*if (this.$refs.vueavatar) {
        return this.$refs.vueavatar.getImageScaled().toDataURL();
      } else {
        return null;
      }*/
      return this.img;
    },
    setImg(image) {
      this.image = image;
      this.img = image;
    },
  },
  components: {
    VueAvatar,
  },
};
</script>
